//The contents of this file have been generated automatically. Do not edit this file.

import * as t from 'io-ts';
import { isRight } from 'fp-ts/lib/Either';
import { fetchGeneralRaw, FetchGeneralRawResponseType } from 'src_common/common/fetch';
import { ApiTimeLog } from 'src_common/server/webDriver/logFormat';


export interface ParamsType {
    universe: string;
}


const createGuard = <A>(code: number, decoder: t.Type<A, A, unknown>): ((data: unknown) => A) => {
    return (data: unknown): A => {
        const decodeResult = decoder.decode(data);
        if (isRight(decodeResult)) {
            return decodeResult.right;
        }
        throw Error(`Response decoding error /website-cms/{universe}/header-link/top_header_navigation_link -> get -> ${code}`);
    };
};

export const Response200IO = t.array(t.interface({
    action_template: t.union([t.null, t.undefined, t.string]),
    competition_id: t.union([t.null, t.undefined, t.number]),
    cta_url: t.union([t.null, t.undefined, t.string]),
    date_from: t.string,
    date_to: t.string,
    display_order: t.union([t.null, t.undefined, t.number]),
    event_id: t.union([t.null, t.undefined, t.string]),
    id: t.number,
    img_url: t.string,
    is_active: t.boolean,
    sport: t.union([t.null, t.undefined, t.string]),
    title: t.string,
    universe: t.string,
    visibility: t.string,
}));
export type Response200Type = Array<{
    action_template?: null | undefined | string;
    competition_id?: null | undefined | number;
    cta_url?: null | undefined | string;
    date_from: string;
    date_to: string;
    display_order?: null | undefined | number;
    event_id?: null | undefined | string;
    id: number;
    img_url: string;
    is_active: boolean;
    sport?: null | undefined | string;
    title: string;
    universe: string;
    visibility: string;
}>;
export const decodeResponse200 = createGuard(200, Response200IO);

export const Response400IO = t.unknown;
export type Response400Type = unknown;
export const decodeResponse400 = createGuard(400, Response400IO);

export const Response401IO = t.unknown;
export type Response401Type = unknown;
export const decodeResponse401 = createGuard(401, Response401IO);

export const Response404IO = t.unknown;
export type Response404Type = unknown;
export const decodeResponse404 = createGuard(404, Response404IO);

export const Response500IO = t.unknown;
export type Response500Type = unknown;
export const decodeResponse500 = createGuard(500, Response500IO);



type ExtraHeadersType = Record<string, string>


/**
 * @deprecated - Please use this method "openapiWebsiteCmsGetTopNavigationLinksRequest"
 */
export const openapi_website_cms_getTopNavigationLinks = async (api_url: string, api_timeout: number, backendToken: string, params: ParamsType, extraHeaders?: ExtraHeadersType): Promise<FetchGeneralRawResponseType> => {
    
        
    const query = '';
    const url = `${api_url}/website-cms/${params.universe}/header-link/top_header_navigation_link${query}`;
    
    const method = 'GET';
    const paramsFetch = {
        url,
        body: undefined,
        backendToken,
        timeout: api_timeout,
        extraHeaders,
    };

    const apiTime = ApiTimeLog.createWithProcessEnv(method, url);
    const response = await fetchGeneralRaw(method, paramsFetch);
    apiTime.show(response.status);
    return response;
};


export type OpenapiWebsiteCmsGetTopNavigationLinksParamsType = ParamsType;

export type OpenapiWebsiteCmsGetTopNavigationLinksResponseType = {
    status: 200;
    body: Response200Type;
} | {
    status: 400;
    body: Response400Type;
} | {
    status: 401;
    body: Response401Type;
} | {
    status: 404;
    body: Response404Type;
} | {
    status: 500;
    body: Response500Type;
};

export type OpenapiWebsiteCmsGetTopNavigationLinksResponse200Type = Response200Type;

export const openapiWebsiteCmsGetTopNavigationLinksRequest = async (api_url: string, api_timeout: number, backendToken: string, params: ParamsType, extraHeaders?: ExtraHeadersType): Promise<OpenapiWebsiteCmsGetTopNavigationLinksResponseType> => {
    const response = await openapi_website_cms_getTopNavigationLinks(api_url, api_timeout, backendToken, params, extraHeaders);
    const { status, body } = response;

    let json = null;

    try {
        json = JSON.parse(body);
    } catch (_err) {
        console.warn(`Http status ${status} - json was expected`);
        json = {};
    }
    
    if (status === 200) {
        return { status: 200, body: decodeResponse200(json) };
    }

    if (status === 400) {
        return { status: 400, body: decodeResponse400(json) };
    }

    if (status === 401) {
        return { status: 401, body: decodeResponse401(json) };
    }

    if (status === 404) {
        return { status: 404, body: decodeResponse404(json) };
    }

    if (status === 500) {
        return { status: 500, body: decodeResponse500(json) };
    }

    throw new Error(`openapiWebsiteCmsGetTopNavigationLinksRequest - unhandled response ${response.status}`);
};

